export const CODELESS_EVENTS_ROOT = 'codeless-events-root';

export const POST_MESSAGES_TYPES = {
    SET_TOKEN: 'taboola_setToken',
    HIGHLIGHT: 'taboola_highlightElements',
    UNHIGHLIGHT: 'taboola_unHighlightElements',
    CLICK: 'taboola_click',
    NAVIGATE_MODE: 'taboola_navigateMode',
    FINISH_NAVIGATE: 'taboola_finishNavigate',
    DRAG_MODE_ON: 'taboola_dragModeOn',
    DRAG_MODE_OFF: 'taboola_dragModeOff',
    SYNC_CONVERSIONS: 'taboola_conversionsData',
    REQUEST_URL: 'taboola_requestUrl',
    URL_RESPONSE: 'taboola_urlResponse',
    EXISTING_CONVERSIONS: 'taboola_existingConversions',
    SHOW_SUCCESS_MODAL: 'taboola_showSuccessModal',
    CENTER_WINDOW: 'taboola_centerWindow',
    RESET_WINDOW_POSITION: 'taboola_resetWindowPosition',
    CLOSE: 'taboola_close',
    VALIDATION_RESULT: 'taboola_validationResult',
};

export const HIGHLIGHT_TYPES = {
    POTENTIAL_ELEMENTS: 'POTENTIAL_ELEMENTS',
    EXISTING_CONVERSIONS: 'EXISTING_CONVERSIONS',
    FOCUSED_CONVERSION: 'FOCUSED_CONVERSION',
    VALUE: 'VALUE',
};

export const SESSION_STORAGE_KEYS = {
    ACCOUNT_ID: 'taboola-account-id',
    NUMERIC_ACCOUNT: 'taboola-numeric-account',
};
